import React, { useState } from "react";

import HamburgerMenuIcon from "@uui/Menu01";

import useUiStore from "@app/analytics/stores/useUiStore";
import useAuth from "@app/common/auth/useAuth";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Avatar from "@rui/Avatar";
import IconButton from "@rui/IconButton";
import { Column } from "@rui/Stack";
import Stack from "@rui/Stack";

import {
  MobileAppBar,
  MobileNavDrawer,
  MobileNavDrawerOuterContent,
  MobileToolbar,
  NAV_BAR_Z_INDEX,
} from "./styles";
import SchedulingLink from "../SideNav/SchedulingLink";
import SideNavAddRead from "../SideNav/SideNavAddRead";
import SideNavContent from "../SideNav/SideNavContent";
import UserNavMenu from "../UserNavMenu";

const MobileNav = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { user } = useAuth();

  const {
    anchorElement,
    open: menuOpen,
    onClick,
    onClose: onCloseMenu,
  } = useAnchorElement();

  const sideNavModalVisible = useUiStore(
    (state) => state.promotionRedeemedModalId != null
  );

  const closeDrawer = () => setDrawerOpen(false);

  return (
    <>
      <Stack flexGrow={1}>
        <MobileAppBar position="fixed">
          <MobileToolbar disableGutters>
            <IconButton
              size="small"
              edge="start"
              aria-label="menu"
              className={drawerOpen ? "focused" : undefined}
              onClick={() => setDrawerOpen((prev) => !prev)}
            >
              <HamburgerMenuIcon />
            </IconButton>

            {user && (
              <Avatar
                size="md"
                name={user.fullName}
                onClick={onClick}
                className={menuOpen ? "focused" : undefined}
              >
                {user.initials}
              </Avatar>
            )}
          </MobileToolbar>
        </MobileAppBar>
      </Stack>

      {/* User Menu on Avatar click */}
      <UserNavMenu
        sx={{ zIndex: NAV_BAR_Z_INDEX }}
        disableScrollLock
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        anchorEl={anchorElement}
        open={menuOpen}
        handleClose={onCloseMenu}
        user={user}
      />

      {/* Nav drawer on logo click */}
      <MobileNavDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <MobileNavDrawerOuterContent>
          <SideNavContent
            onClickMenuItem={closeDrawer}
            onClose={closeDrawer}
            open={drawerOpen}
            sideNavModalVisible={sideNavModalVisible}
          />
          <Column spacing={1} pb={2}>
            <SideNavAddRead expanded={drawerOpen} />
            <SchedulingLink expanded={drawerOpen} />
          </Column>
        </MobileNavDrawerOuterContent>
      </MobileNavDrawer>
    </>
  );
};

export default MobileNav;
